import dayjs from 'dayjs';

export const unixToLocalDate = (unixTimestamp) => {
  const d = dayjs.unix(unixTimestamp);
  return d.format('DD.MM.YYYY HH:mm');
};

/** Format value already in kW to 4 fixed decimal places (for display). */
export const formatKw = (value) =>
  (Number(value) ?? 0).toFixed(4);

/** Format value in watts to kW string with 4 fixed decimal places. */
export const formatKwFromWatts = (value) =>
  ((Number(value) ?? 0) / 1000).toFixed(4);

/** Format value already in kWh to 4 fixed decimal places (for display). */
export const formatKwh = (value) =>
  (Number(value) ?? 0).toFixed(4);

/** Format value in Wh to kWh string with 4 fixed decimal places. */
export const formatKwhFromWatts = (value) =>
  ((Number(value) ?? 0) / 1000).toFixed(3);

/** Format number for report/TOU display with comma decimal (matches InputNumber). */
export const formatReportNumber = (value) =>
  (Number(value) ?? 0).toLocaleString('tr-TR');
